import React from 'react';
import { ArrowLeft, Car, Shield, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { logoUrl } from '../mockData';
import { FormDinamico } from '../components/FormDinamico';

const BastaLaTarga = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-[#1B2380] hover:text-[#0E8C84] transition-colors duration-300"
            >
              <ArrowLeft size={20} />
              <span className="font-medium">Torna alla Home</span>
            </button>
            <img src={logoUrl} alt="Assietica" className="h-12 w-auto" />
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="bg-[#1B2380] text-white py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="inline-block bg-[#E74C3C] text-white text-xs font-bold uppercase tracking-wide rounded-full px-4 py-1.5 mb-5">RC Auto — Persone e famiglie</span>
          <div className="w-20 h-20 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6">
            <Car className="text-white" size={40} />
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            Basta la Targa
          </h1>
          <p className="text-lg sm:text-xl text-white/90 max-w-2xl mx-auto mb-6">
            Richiedi la tua quotazione RCA in pochi semplici passi. 
            Vantaggi esclusivi per il mondo del Terzo Settore e delle Cooperative.
          </p>
          
          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center gap-4 mt-8">
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full">
              <Shield size={18} />
              <span className="text-sm font-medium">Preventivo Gratuito</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full">
              <CheckCircle size={18} />
              <span className="text-sm font-medium">Risposta in 24h</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full">
              <Car size={18} />
              <span className="text-sm font-medium">Agevolazioni ETS</span>
            </div>
          </div>
        </div>
      </div>

      {/* Form Section */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 -mt-8">
        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-10" data-testid="bastalatarga-form-card">
          <FormDinamico formKey="basta_targa" />
        </div>
      </main>

      {/* Info Box */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        <div className="bg-[#1B2380]/10 rounded-xl p-6 border border-[#1B2380]/30">
          <h3 className="font-semibold text-gray-800 mb-3">Hai bisogno di assistenza?</h3>
          <p className="text-gray-600 text-sm mb-4">
            Se hai difficolta nella compilazione o preferisci un contatto diretto, siamo a disposizione:
          </p>
          <div className="flex flex-wrap gap-4 text-sm">
            <a href="tel:+390785747193" className="text-[#1B2380] hover:underline flex items-center">
              <span className="mr-1">Tel:</span> 0785 747193
            </a>
            <a href="tel:+393737288673" className="text-[#1B2380] hover:underline flex items-center">
              <span className="mr-1">Cell:</span> 373 7288673
            </a>
            <a href="mailto:agenzia@assietica.it" className="text-[#1B2380] hover:underline flex items-center">
              <span className="mr-1">Email:</span> agenzia@assietica.it
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#10154F] text-white py-6">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Assietica Societa Cooperativa. Tutti i diritti riservati.
          </p>
          <p className="text-xs text-white/50 mt-2">
            Intermediario iscritto al RUI A000480096 - Vigilanza IVASS
          </p>
        </div>
      </footer>
    </div>
  );
};

export default BastaLaTarga;
